import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const margin = '20px';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 30px;

  > li,
  article {
    width: 100%;
    margin: 15px;
  }

  &.column {
    flex-direction: column;

    > div:nth-child(n),
    article:nth-child(n) {
      max-width: 100%;
    }
  }

  &.center-aligned,
  &.center {
    flex-direction: column;
    text-align: center;

    > div:nth-child(n),
    article:nth-child(n) {
      max-width: 100%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.center-aligned,
    &.center {
      div.title {
        margin-bottom: 30px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: row;
    align-items: center;

    &.center-aligned,
    &.center {
      div.title {
        margin-bottom: 40px;
      }
    }

    &.left-aligned,
    &.left {
      div.title {
        margin-bottom: 40px;
      }
    }

    > div:nth-child(1n),
    article:nth-child(1n) {
      max-width: 400px;
    }

    > div:nth-child(2n),
    article:nth-child(2n) {
      max-width: 820px;
    }

    > div.title {
      max-width: 100% !important;
    }
  }
`;

export const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${margin};

  > li,
  article {
    width: 100%;
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    &.product-card {
      margin: -60px -${margin};
      /* 168px * 0.55 bc 168px is the max height of the product card images on mobile, and they are displaced 0.45% of the Y value */
      padding-top: calc(168px * 0.55);
      > li,
      article {
        margin: 60px ${margin};
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;

    > li,
    article {
      /* Width of each card is equal to 100% width / amount of cards per row - (margin * 2) as we want to subtract it equally from both sides */
      width: calc(
        (100% / ${({ columnCount }) => columnCount}) - (${margin} / 2)
      );

      @supports (-ms-ime-align: auto) {
        width: calc(
          (100% / ${({ columnCount }) => columnCount}) - (${margin}) - 1px
        );
      }
    }

    &.product-card {
      /* TODO Set this up to use fluid type */
      padding-top: 100px;
    }

    &.feature-card {
      > li {
        width: calc((100% / 2) - (${margin} / 2));

        @supports (-ms-ime-align: auto) {
          /* Fixes Edge */
          width: calc((100% / 2) - (${margin} / 2) - 1px);
        }
      }
    }
  }

  /* Fixes IE for feature cards*/
  @media only screen and (min-width: ${themeGet(
      'breakpoints.md',
    )}) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    > li,
    article {
      width: calc(
        (100% / ${({ columnCount }) => columnCount}) - (${margin}) - 1px
      );
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    justify-content: center;
    &.feature-card {
      > li {
        width: calc(
          (100% / ${({ columnCount }) => columnCount}) -
            (${margin} * 2 / ${({ columnCount }) => columnCount})
        );

        @supports (-ms-ime-align: auto) {
          /* Fixes Edge */
          width: calc(
            (100% / ${({ columnCount }) => columnCount}) -
              (${margin} * 2 / ${({ columnCount }) => columnCount}) - 1px
          );
        }
      }
    }
  }
`;

export const ShowMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 0 0 0;
  margin-bottom: 4rem;

  span {
    padding-bottom: 1px;
    border-bottom: 1px solid currentColor;
    font-weight: ${themeGet('fontWeights.medium')};
  }

  &:hover {
    span {
      color: ${themeGet('colors.pc-red', '#E1251B')};
      border-bottom: 1px solid ${themeGet('colors.pc-red', '#E1251B')};
    }
  }
`;
